import { render } from "./MainMenu.vue?vue&type=template&id=336c0c68"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"
script.render = render

export default script